import styled from 'styled-components';

export const ContentStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;
  position: relative;
  min-height: 25rem;
  width: 100%;
`;
